import type { HTMLAttributes } from 'react';
import { X } from '@phosphor-icons/react';
import { cn } from '@skupreme/shared/ui';
import { CommonUtility } from '@utility/common';
import { theme as themeUtils } from '@utility/theme';

type ShippingLabelContainerProps = HTMLAttributes<HTMLDivElement> & {
  onClose?: () => void;
};

/* Sits under the app header, whose height the theme owns. */
const panelOffset = {
  top: themeUtils.sizes.headerHeight,
  height: `calc(100vh - ${themeUtils.sizes.headerHeight}px)`,
};

export function ShippingLabelContainer({
  children,
  onClose,
  className,
  style,
  ...props
}: ShippingLabelContainerProps) {
  return (
    <div
      {...props}
      style={{ ...panelOffset, ...style }}
      className={cn(
        'sk:absolute sk:right-0 sk:z-999 sk:box-border sk:w-[60%] sk:max-w-[500px] sk:max-sm:w-[calc(100%-40px)]',
        'sk:rounded-card sk:bg-surface sk:p-5 sk:shadow-card sk:inset-shadow-hairline',
        'sk:[&_.header]:sticky sk:[&_.header]:top-0 sk:[&_.header]:z-1 sk:[&_.header]:bg-surface sk:[&_.header]:pb-[5px]',
        className,
      )}
    >
      {CommonUtility.isFunction(onClose) && (
        <button
          type="button"
          aria-label="Close"
          onClick={onClose}
          className={cn(
            'sk:absolute sk:top-1/2 sk:-left-[39px] sk:flex sk:size-10 sk:-translate-y-1/2 sk:items-center sk:justify-center',
            'sk:m-0 sk:cursor-pointer sk:appearance-none sk:border-0 sk:rounded-l-md sk:bg-surface sk:text-fg-secondary sk:inset-shadow-hairline',
            'sk:hover:bg-fill-tertiary sk:hover:text-fg',
          )}
        >
          <X size={20} />
        </button>
      )}
      {children}
    </div>
  );
}
